<template>
  <el-dialog v-model="visible" class="login" align-center @close="close">
    <div class="box">
      <div class="header">
        <template v-if="!status.binding">
          <img
            :src="status.scan ? '/icon/sjhmdl.png' : '/icon/appsmdl.png'"
            alt=""
            style="position: relative; right: -16px"
          />
          <div class="mask"></div>
          <img
            :src="status.scan ? '/background/shoujidl.png' : '/background/erweima.png'"
            alt=""
            style="cursor: pointer"
            v-yt-push="{ btnName: '登录弹窗-登录方式切换' }"
            @click="handoff"
          />
        </template>
      </div>
      <div v-if="status.scan && !status.binding">
        <div class="QRcode">
          <div class="QRcode-box" style="padding: 12px">
            <div ref="qrcode"></div>
          </div>
          <img class="icon" src="/image/ytptesm.png" alt="" />
        </div>
        <div class="tips">打开羊驼PTEAPP点击首页右上角“扫一扫”</div>
      </div>
      <div class="form-box" v-else>
        <div class="title-row">
          <span>{{
            status.binding ? '绑定手机号' : loginMode === 'sms' ? '手机验证码登录' : '账号密码登录'
          }}</span>
          <span
            v-if="!status.binding"
            v-yt-push="{
              btnName: loginMode === 'sms' ? '登录-切换账号密码登录' : '登录-切换手机验证码登录'
            }"
            class="mode-link"
            @click="switchMode(loginMode === 'sms' ? 'password' : 'sms')"
            >{{ loginMode === 'sms' ? '账号密码登录' : '手机验证码登录' }} &gt;</span
          >
        </div>
        <el-form
          v-if="loginMode === 'sms'"
          ref="form"
          :rules="rules"
          :model="formData"
          label-width="0"
          size="large"
        >
          <el-form-item prop="phone" style="margin-bottom: 10px" :show-message="false">
            <el-input v-model="formData.phone" placeholder="请输入手机号">
              <template #prefix>
                <el-dropdown trigger="click" max-height="300px" @command="select">
                  <div style="display: flex; align-items: center">
                    <span style="line-height: 0; min-width: 36px">+{{ formData.phonecode }}</span>
                    <el-icon style="margin-left: 2px">
                      <CaretBottom />
                    </el-icon>
                  </div>
                  <template #dropdown>
                    <el-dropdown-menu style="padding: 2px 0">
                      <el-dropdown-item v-for="item in options" :command="item.phonecode"
                        >+{{ item.phonecode }}</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="code">
            <div style="display: flex">
              <el-input v-model="formData.code" placeholder="请输入验证码" />
              <el-button
                v-yt-push="{ btnName: '登录弹窗-获取验证码' }"
                style="margin-left: 10px"
                @click="send"
                :disabled="status.disabled"
                >{{ status.disabled ? `${status.second}秒后重试` : '获取验证码' }}</el-button
              >
            </div>
          </el-form-item>
          <el-form-item style="margin: 0">
            <el-button
              type="primary"
              v-yt-push="{ btnName: '登录弹窗-登录提交' }"
              class="button"
              @click="submit"
            >
              {{ status.binding ? '绑定' : '登录/注册' }}
            </el-button>
          </el-form-item>
          <el-form-item>
            <div
              v-if="isVoicePhone && voiceAppeared"
              v-yt-push="{ btnName: `登录-语音验证码` }"
              class="voice-link"
              :class="{ loading: voiceLoading, 'is-disabled': status.disabled }"
              @click="sendVoiceCode"
            >
              收不到?语音接听
            </div>
            <span
              v-else-if="!voiceAppeared"
              style="color: var(--el-color-primary); cursor: pointer"
              @click="status.show = true"
              v-yt-push="{ btnName: '登录弹窗-无法获取验证码' }"
              >无法获取验证码？</span
            >
          </el-form-item>
        </el-form>
        <el-form
          v-else
          ref="pwdForm"
          :rules="pwdRules"
          :model="pwdFormData"
          label-width="0"
          size="large"
        >
          <el-form-item prop="phone" style="margin-bottom: 10px" :show-message="false">
            <el-input v-model="pwdFormData.phone" placeholder="请输入手机号">
              <template #prefix>
                <el-dropdown trigger="click" max-height="300px" @command="selectPwd">
                  <div style="display: flex; align-items: center">
                    <span style="line-height: 0; min-width: 36px"
                      >+{{ pwdFormData.phonecode }}</span
                    >
                    <el-icon style="margin-left: 2px">
                      <CaretBottom />
                    </el-icon>
                  </div>
                  <template #dropdown>
                    <el-dropdown-menu style="padding: 2px 0">
                      <el-dropdown-item v-for="item in options" :command="item.phonecode"
                        >+{{ item.phonecode }}</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input
              v-model="pwdFormData.password"
              :type="pwdVisible ? 'text' : 'password'"
              placeholder="请输入密码"
              @keyup.enter="submitByPassword"
            >
              <template #suffix>
                <el-icon class="pwd-eye" @click="pwdVisible = !pwdVisible">
                  <View v-if="pwdVisible" />
                  <Hide v-else />
                </el-icon>
              </template>
            </el-input>
          </el-form-item>
          <div
            v-yt-push="{ btnName: `登录-忘记密码切验证码` }"
            class="forget-link"
            @click="switchMode('sms')"
          >
            忘记密码？验证码登录
          </div>
          <el-form-item style="margin: 0">
            <el-button
              type="primary"
              v-yt-push="{ btnName: `密码登录` }"
              class="button"
              :loading="pwdLoading"
              @click="submitByPassword"
            >
              登录
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="agreement-box">
        <span
          v-yt-push="{ btnName: '登录弹窗-用户协议勾选' }"
          @click="setAgreement"
          :class="{ active: agreement }"
          class="radio"
        ></span>
        <p class="text">
          我已阅读并且同意<a
            href="https://www.yangtuoedu.com/privacy-policy/user-agreements/userAgreement-pte.html"
            target="_blank"
            rel="noopener noreferrer"
            >《羊驼PTE用户协议》</a
          >
          和
          <a
            href="https://www.yangtuoedu.com/privacy-policy?appType=25"
            target="_blank"
            rel="noopener noreferrer"
            >《羊驼PTE隐私政策》</a
          >
        </p>
      </div>
    </div>
    <el-dialog v-model="status.show" class="tips-dialog" width="500" align-center>
      <img src="/image/wfhqyzm.png" width="100%" alt="" />
    </el-dialog>
  </el-dialog>
</template>

<script setup lang="ts">
import {
  ElDialog,
  ElInput,
  ElButton,
  ElFormItem,
  ElForm,
  ElDropdown,
  ElDropdownMenu,
  ElDropdownItem,
  ElIcon,
  ElMessage
} from 'element-plus'
import { CaretBottom, Hide, View } from '@element-plus/icons-vue'
import { http } from '@/utils'
import { grantPrivacyConsent } from '@/utils/privacy-consent'
import { saveToken } from '@/utils/token'
import { computed, ref, reactive, nextTick } from 'vue'
import { md5 } from 'js-md5'

// @ts-ignore
import QRCode from 'qrcodejs2-fix'
import { useUserStore } from '@/store/user.store'
import { useRoute } from 'vue-router'
const route = useRoute()

console.log(route)

const userStore = useUserStore()
const rules = {
  phone: { required: true, message: '', trigger: 'blur' },
  code: { required: true, message: '请输入验证码', trigger: 'blur' }
}

const status = reactive({
  scan: false,
  binding: false,
  uuid: '',
  disabled: false,
  show: false,
  second: 60
})
const agreement = ref(false)
const setAgreement = () => {
  agreement.value = !agreement.value
}
let countdown: any
let tick: any
const visible = ref(true)
const qrcode = ref()
const form = ref()
const options = reactive<any>([])
const formData = reactive<{
  phone?: string
  code?: string
  phonecode: number
  userCode?: string
}>({
  phonecode: 86
})

// 登录方式：sms 手机验证码登录 / password 账号密码登录
const loginMode = ref<'sms' | 'password'>('sms')
const switchMode = (mode: 'sms' | 'password') => {
  loginMode.value = mode
}
// 账号密码登录表单
const pwdForm = ref()
const pwdVisible = ref(false)
const pwdLoading = ref(false)
const pwdRules = {
  phone: { required: true, message: '请输入手机号', trigger: 'blur' },
  password: { required: true, message: '请输入密码', trigger: 'blur' }
}
const pwdFormData = reactive<{ phone?: string; password?: string; phonecode: number }>({
  phonecode: 86
})
const selectPwd = (val: number) => (pwdFormData.phonecode = val)
// 语音验证码：短信/语音发送 50 秒后显示入口，且仅支持 +86 中国大陆号码
const isVoicePhone = computed(() => formData.phonecode === 86)
/** 语音入口是否已出现：发送 50 秒后置真，之后不随倒计时归零消失 */
const voiceAppeared = ref(false)
const voiceLoading = ref(false)

const clearCountdown = () => {
  status.second = 60
  status.disabled = false
  clearInterval(countdown)
}

// 关闭登录流程时复位语音入口状态
const resetVoiceEntry = () => {
  voiceAppeared.value = false
  voiceLoading.value = false
}

// 短信/语音验证码共用同一套 60s 倒计时
const startCountdown = () => {
  // 语音在倒计时结束前重发时需清掉旧计时器，避免双计时器导致倒计时加速
  clearInterval(countdown)
  status.second = 60
  status.disabled = true
  voiceAppeared.value = false
  countdown = window.setInterval(() => {
    if (status.second) {
      status.second--
      // 发送 50 秒后（倒计时剩余 10 秒）显示语音验证码入口
      if (status.second <= 10) {
        voiceAppeared.value = true
      }
    } else {
      clearCountdown()
    }
  }, 1000)
}
function setAuthHeaders(param: { ts: number; phone: string }) {
  return {
    userAgent: navigator.userAgent,
    ts: param.ts,
    expire: 300,
    clientType: 'pcweb',
    phone: param.phone
  }
}
function sortASCII(obj: { [x: string]: any }, isSort = true) {
  let arr: string[] = []
  Object.keys(obj).forEach((item) => arr.push(item))
  let sortArr = isSort ? arr.sort() : arr.sort().reverse()
  let sortObj: { [key: string]: string } = {}
  for (let i in sortArr) {
    sortObj[sortArr[i]] = obj[sortArr[i]]
  }
  return sortObj
}
function setMD5Accsii(Headers: any) {
  const payload = sortASCII(Headers)
  let payloadStr = ''
  Object.keys(payload).forEach((K) => {
    payloadStr += `${K}=${payload[K]}&`
  })
  payloadStr += 'key=yangtuoedu'
  return md5(payloadStr)
}

const send = async () => {
  // 与语音验证码、登录一致：未勾选协议不发起短信下发（下发本身即在处理手机号）
  if (!agreement.value) {
    return ElMessage.warning('请阅读并且同意用户协议')
  }
  try {
    await form.value.validateField('phone')
  } catch {
    // 手机号未填写时校验会 reject，需手动提示，否则点击“获取验证码”后无任何反馈
    return ElMessage.warning('请输入手机号')
  }
  startCountdown()
  try {
    const header = setAuthHeaders({
      phone: formData.phone as string,
      ts: Date.now()
    })
    const sign = setMD5Accsii(header).toUpperCase()
    await http.post(
      '/api/message/sendSms',
      {
        ...formData,
        sign
      },
      {
        headers: header as any
      }
    )
  } catch {
    clearCountdown()
  }
}

// 语音验证码：验签与获取短信验证码一致
const sendVoiceCode = async () => {
  if (!agreement.value) {
    return ElMessage.warning('请阅读并且同意用户协议')
  }
  if (!formData.phone) {
    return ElMessage.warning('请输入手机号')
  }
  if (!isVoicePhone.value) {
    return ElMessage.warning('语音验证码仅支持 +86 手机号')
  }
  if (!/^1[3-9]\d{9}$/.test(formData.phone)) {
    return ElMessage.warning('请输入正确的手机号')
  }
  // 共用一套 60s 冷却：冷却期内语音入口只置灰不隐藏，避免连续发起语音呼叫
  if (status.disabled) {
    return ElMessage.warning('请等待短信验证码倒计时结束')
  }
  if (voiceLoading.value) return
  voiceLoading.value = true
  const header = setAuthHeaders({
    phone: formData.phone as string,
    ts: Date.now()
  })
  const sign = setMD5Accsii(header).toUpperCase()
  try {
    await http.post(
      '/api/message/sendVoiceCode',
      {
        ...formData,
        sign
      },
      {
        headers: header as any
      }
    )
    ElMessage.success('语音验证码获取成功，请注意接听电话')
    startCountdown()
  } catch {
    // 失败提示由 http 拦截器统一处理
  } finally {
    voiceLoading.value = false
  }
}

const handoff = () => {
  if (!agreement.value) {
    return ElMessage.warning('请阅读并且同意用户协议')
  }
  loginMode.value = 'sms'
  status.scan = !status.scan
  clearInterval(tick)
  if (status.scan) load()
}

const load = () => {
  status.uuid = 'xxxxxxxx-xxxx-xxxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
  nextTick(
    () =>
      new QRCode(qrcode.value, {
        text: JSON.stringify('logincode=' + status.uuid),
        width: 140,
        height: 140
      })
  )
  tick = window.setInterval(polling, 1000)
}

const polling = () => {
  http.get('/api/user/giveTokenByUUID', { uuid: status.uuid }, { skipMsg: true }).then((res) => {
    if (!res.data) return
    // 扫码入口已要求勾选协议，登录成功同样视为同意隐私政策
    grantPrivacyConsent()
    saveToken(res.data)
    location.reload()
    visible.value = false
  })
}

// 登录成功统一处理（短信登录 / 密码登录共用）
const handleLoginSuccess = (res: any) => {
  // 登录成功清理语音验证码入口
  resetVoiceEntry()
  // 用户已勾选并同意《用户服务协议》和《隐私政策》，视为同意隐私政策，启用统计SDK
  grantPrivacyConsent()
  saveToken(res.data.token)
  const search = new URLSearchParams(window.location.search)
  const CallBackUrl = search.get('CallBackUrl')
  if (CallBackUrl) {
    window.location.href = window.location.origin + decodeURIComponent(CallBackUrl)
  } else {
    location.reload()
  }

  visible.value = false
  userStore.getUserInfo()
}

const submitLoading = ref(false)
const submit = () => {
  if (!agreement.value) {
    return ElMessage.warning('请阅读并且同意用户协议')
  }
  form.value
    .validate()
    .then((valid: any) => {
      if (!valid) return
      submitLoading.value = true
      return http
        .post(status.binding ? '/api/auth/bindingPhone' : '/api/auth/loginPhone', formData)
        .then(handleLoginSuccess)
        .finally(() => {
          submitLoading.value = false
        })
    })
    // 兜住校验 reject 与登录接口失败（两者的提示分别由表单内联和 http 拦截器给出），
    // 避免 Promise 链产生未捕获异常
    .catch(() => {})
}

// 账号密码登录
const submitByPassword = () => {
  if (!agreement.value) {
    return ElMessage.warning('请阅读并且同意用户协议')
  }
  // 用阶段标记区分「校验不通过」和「登录接口失败」：
  // 后者若被误判成校验问题会弹出误导性的“请输入手机号”
  let stage: 'validate' | 'login' = 'validate'
  pwdForm.value
    .validate()
    .then((valid: any) => {
      if (!valid) return
      stage = 'login'
      pwdLoading.value = true
      return http
        .post<{ token: string; expireIn: number }>('/api/user/password/login', {
          phone: pwdFormData.phone || '',
          password: pwdFormData.password || ''
        })
        .then(handleLoginSuccess)
        .finally(() => (pwdLoading.value = false))
    })
    .catch((err: any) => {
      if (stage === 'validate') ElMessage.warning('请输入手机号')
      else if (err instanceof Error) console.error('密码登录异常:', err)
      // 接口业务错误已由 http 拦截器弹窗，这里不再重复提示
    })
}

http.post('/api/message/countryList').then((res) => {
  options.push(...res.data)
})

const select = (val: number) => (formData.phonecode = val)

const close = () => {
  clearInterval(tick)
  clearInterval(countdown)
  resetVoiceEntry()
}
</script>

<style lang="scss">
.tips-dialog {
  padding: 0 !important;
  border-radius: 30px !important;
}

.login {
  width: 440px !important;
  padding: 0 !important;
  border-radius: 30px !important;

  .el-dialog__header {
    padding-top: 0 !important;
  }

  .el-dialog__body {
    overflow: hidden;
    border-radius: 30px;
  }
}
</style>

<style lang="scss" scoped>
.box {
  padding-bottom: 60px;

  .header {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    position: relative;
    height: 84px;

    .mask {
      position: absolute;
      right: 0;
      width: 83px;
      height: 100%;
      z-index: 1;
      clip-path: polygon(100% 100%, 0% 100%, 0 0%, 0 0);
    }
  }
  .form-box {
    padding: 0 64px;
    position: relative;

    .title-row {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      font-size: 22px;
      font-weight: bold;
      margin-bottom: 22px;
    }

    .mode-link {
      margin-left: 8px;
      // 与大号标题的文字底部对齐（小字号行盒下沉，补 2px）
      margin-bottom: 2px;
      font-size: 14px;
      font-weight: 500;
      color: var(--el-color-primary);
      cursor: pointer;
      user-select: none;

      &:hover {
        opacity: 0.85;
      }
    }

    .pwd-eye {
      cursor: pointer;
      color: var(--el-text-color-disabled);

      &:hover {
        color: var(--el-color-primary);
      }
    }

    .forget-link {
      text-align: right;
      font-size: 13px;
      font-weight: 500;
      color: var(--el-color-primary);
      cursor: pointer;
      margin: 2px 0 16px;

      &:hover {
        opacity: 0.85;
      }
    }

    .voice-link {
      display: inline-block;
      font-size: 14px;
      font-weight: 500;
      color: var(--el-color-primary);
      cursor: pointer;

      &:hover {
        opacity: 0.85;
      }

      &.loading {
        opacity: 0.6;
        cursor: not-allowed;
      }

      // 共用冷却倒计时内：入口保留但置灰，点击提示等待
      &.is-disabled {
        color: var(--el-text-color-disabled);

        &:hover {
          opacity: 1;
        }
      }
    }
  }

  .QRcode {
    background: #f8f7fc;
    border-radius: 19px;
    margin: 0px 32px;
    padding: 16px 20px;
    display: flex;
    gap: 0 25px;

    .QRcode-box {
      width: 164px;
      height: 164px;
      background-color: #fff;
      position: relative;
      flex: none;
      :deep(img) {
        width: 100%;
        height: 100%;
      }
    }
    .icon {
      flex: 1;
      width: 120px;
    }
  }

  .tips {
    margin-top: 10px;
    text-align: center;
  }

  .phonecode {
    :deep(.el-select__icon) {
      margin: 0;
    }

    :deep(.el-input__validateIcon) {
      display: none;
    }
  }

  .button {
    width: 100%;
  }

  .agreement-box {
    margin-top: 15px;
    padding: 0 64px;
    font-size: var(--el-font-size-base);
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
    gap: 0 6px;
    color: var(--el-text-color-content);

    .radio {
      position: relative;
      cursor: pointer;
      display: block;
      width: 16px;
      height: 16px;
      margin-top: 5px;
      background-image: url(@/assets/images/icon/wxz@2x.png);
      background-size: 100% 100%;
      &.active {
        background-image: url(@/assets/images/icon/xz@2x.png);
      }
    }
    .text {
      font-size: var(--el-font-size-base);
      line-height: 1.5;
      vertical-align: text-top;
      flex: 1;
      a {
        color: var(--el-color-primary);
      }
    }
  }
}
</style>
<style lang="scss">
.login {
  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__headerbtn {
    width: 32px;
    height: 32px;
    right: -32px;
    top: -16px;

    .el-dialog__close {
      color: #fff;
      font-size: var(--el-font-size-extra-large);
    }
  }
}
</style>
